import React from "react";
import { useLocation } from "react-router-dom";

export default function PaymentSuccess() {
  const { state } = useLocation();
  const response = state?.paymentResponse;

  return (
    <div className="p-6 text-center">
      <h1 className="text-2xl font-bold mb-4">Payment Successful!</h1>
      {response ? (
        <pre className="text-left bg-gray-100 p-4 rounded">{JSON.stringify(response, null, 2)}</pre>
      ) : (
        <p>Payment details not available.</p>
      )}
    </div>
  );
}
